/** @format */

import React, { useState, ReactNode } from 'react'
import { _$, Icon } from '@king-design/react'
import styled from 'styled-components'

interface CollapsibleListProps<T> {
  /** 数据列表 */
  data: T[]
  /** 渲染每个列表项的函数 */
  renderItem: (item: T, index: number) => ReactNode
  /** 默认显示的数量，默认为5 */
  defaultCount?: number
  /** 自定义"查看全部"文本，默认为"查看全部" */
  expandText?: string
  /** 自定义"收起"文本，默认为"收起" */
  collapseText?: string
  /** 自定义类名 */
  className?: string
  /** 列表项的key生成函数 */
  getItemKey?: (item: T, index: number) => string | number
}

const CollapsibleList = <T,>({
  data = [],
  renderItem,
  defaultCount = 5,
  expandText = _$('展开全部'),
  collapseText = _$('收起'),
  className,
  getItemKey
}: CollapsibleListProps<T>) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const shouldShowExpand = data.length > defaultCount
  const displayData = isExpanded ? data : data.slice(0, defaultCount)

  return (
    <CollapsibleListWrapper className={className}>
      <div className="collapsible-list">
        {displayData.map((item, index) => {
          const key = getItemKey ? getItemKey(item, index) : index
          return (
            <div key={key} className="collapsible-list-item">
              {renderItem(item, index)}
            </div>
          )
        })}
      </div>
      {shouldShowExpand && (
        <div className="collapsible-list-toggle" onClick={() => setIsExpanded(!isExpanded)}>
          <span>
            {isExpanded ? collapseText : `${expandText}(${_$('共{n}条', { n: data.length })})`}
          </span>
          <Icon className={isExpanded ? 'ion-chevron-up' : 'ion-chevron-down'} size="mini" />
        </div>
      )}
    </CollapsibleListWrapper>
  )
}

const CollapsibleListWrapper = styled.div`
  .collapsible-list {
    .collapsible-list-item {
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .collapsible-list-toggle {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    color: #1890ff;
    font-size: 12px;
    user-select: none;
    transition: color 0.3s;

    &:hover {
      color: #40a9ff;
    }

    .k-icon {
      margin-left: 4px;
      transition: transform 0.3s;
      color: #1890ff;
      &:hover {
        color: #40a9ff;
      }
    }
  }
`

export default CollapsibleList
